import { z } from 'zod'
import { useZorm } from 'react-zorm'
import { FormField, fieldDescription } from '@codecorp/zorm-conventions'
import { ShowBarcode } from '../components/show-barcode'
import { CreatorButtons } from '../components/creator-buttons'
import { crqcc } from '@codecorp/barcode-data-generator'
import { useFormReset } from '../hooks/use-form'
import { useShowModal } from '../hooks/use-show-modal'

const FormSchema = z.object({
    label: z.string().describe(
        fieldDescription({
            placeHolder: 'This name will be placed under the QR Code.',
        })
    ),
    contents: z
        .string()
        .regex(/^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/)
        .transform((mac) => mac.replace(/[:-]/g, '').toUpperCase())
        .describe(
            fieldDescription({
                label: 'Data to Encode',
                placeHolder: 'Enter BT Address',
            })
        ),
})

export const QuickConnectBarcodeCreator = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)
    const showModal = useShowModal()

    const zo = useZorm('crqccBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label}
                    barcode={crqcc(data.contents)}
                />
            )
        },
    })

    return (
        <div>
            <form
                ref={zo.ref}
                className="ml-10 mr-10 leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.contents(FormField)}
                <CreatorButtons />
            </form>
        </div>
    )
}
